var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"record",on:{"click":function($event){return _vm.$router.push({ name:'details', query: { id: _vm.id } })}}},[_c('img',{attrs:{"src":_vm.image}}),_c('h2',[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }